import { render, staticRenderFns } from "./company-share.vue?vue&type=template&id=00a9a2c4&scoped=true&"
import script from "./company-share.vue?vue&type=script&lang=js&"
export * from "./company-share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a9a2c4",
  null
  
)

export default component.exports